import { View } from "react-native"
import Bell from "@/assets/icons/bell.svg"
import TooltipArrow from "@/assets/icons/tooltip-arrow.svg"
import { H7 } from "@/components/standard/BFText"

export default function BuyBoxTooltip() {
  return (
    <View className="absolute top-[40px] right-[26px] flex w-[133px] h-[20px]">
      <View className="flex flex-row bg-neon-yellow p-2">
        <Bell width={11} height={14} />
        <H7 className="text-midnight-blue pl-1">Set up your Buy Box!</H7>
      </View>
      <View className="flex items-end pt-0 pr-[40px]">
        <TooltipArrow width={12} height={6} />
      </View>
    </View>
  )
}
